import React, { useMemo, useRef, useState } from "react"
import { useQueryClient } from "react-query"
import { useSearchResultsContext } from "../../CandidatsRechercheResults"
import { addStatut, removeStatut, replaceCurriculum } from "../../../../core/_requests"
import { ISearchResultsDataItemResponseModel, ISearchResultsResponseModel } from "../../core/_models"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import {
     CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL,
     CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL,
     CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE,
     CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES,
     CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO,
     CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE,
     CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT,
     CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION,
     CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS,
     CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE,
     CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR,
     CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE,
     CONST_DEFAULT_TOAST_OPTIONS,
} from "@common-constants/*"
import MyTooltip from "@common-utils/MyTooltip"
import { getSelectedCandidatePlusPreviousAndNextCandidate } from "../../core/helpers"
import { toast } from "react-toastify"
import axios, { AxiosError } from "axios"
import { CONST_API_RECRUITMENT_CANDIDATES_GET_DOWNLOAD_CURRICULUM_ENDPOINT, CONST_API_RECRUITMENT_CANDIDATES_POST_ADD_BLACKLIST_ENDPOINT } from "../../../../../../../endpoints"
import FileAndDriveHelper from "@common-helpers/FileAndDriveHelper"
import MyModal from "@common-utils/MyModal"
import CandidatAddSuiviMessageRepondeurForm from "../../../../suivi/_CandidatAddSuiviMessageRepondeur"
import { useSearchResultsPreviewContext } from "../_CandidatsRechercheResultsPreview"
import { IConsultantDEModel } from "@common-models/*"
import { useNavigate } from "react-router-dom"
import CandidatDemanderInfoPreEmbaucheParMail from "../../../../actions/_CandidatDemanderInfoPreEmbaucheParMail"
import CandidatEntamerDemandeEmbauche from "../../../../actions/_CandidatEntamerDemandeEmbauche"
import CandidatAddSuiviTelForm from "../../../../suivi/tel/CandidatAddSuiviTelForm"
import CandidatAddSuiviEntretienAgenceOuVisioForm from "../../../../suivi/agenceVisio/CandidatAddSuiviEntretienAgenceOuVisioForm"
import CandidatAddSuiviEntretienQualifForm from "../../../../suivi/qualif/CandidatAddSuiviEntretienQualifForm"
import { REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY } from "../../../../suivi/listing/CandidatSuiviListing"
import { REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY } from "./_CandidatsRechercheResultsPreviewHelpersDetails"
import { useAuth } from "../../../../../../../AppContext"
import MyEditorField from "@common-utils/fields/MyEditorField"
import CandidatAddSuiviCommentaireSimple from "../../../../suivi/_CandidatAddSuiviCommentaireSimple"

/* Item navigation: switch from one item to another */
export const ItemNavigationArrows = () => {
     const globalContext = useSearchResultsContext()

     // Handles navigation to previous candidate
     function handleNavigateToPreviousCandidate() {
          if (!globalContext.itemInPreview) return

          if (globalContext.itemInPreview.previousItem) {
               globalContext.setItemInPreview(
                    getSelectedCandidatePlusPreviousAndNextCandidate(
                         globalContext.itemInPreview!.previousItem as ISearchResultsDataItemResponseModel,
                         globalContext.itemInPreview!.selectedItemIndex - 1,
                         globalContext.listingQuery.data!.data,
                         globalContext.listingQuery.data!.page,
                         globalContext.listingQuery.data!.totalPages
                    )
               )

               if (Array.isArray(globalContext.filters.filters?.annonces) && (globalContext.filters?.filters?.annonces?.length ?? 0) > 0) {
                    globalContext.checkItemAsSeen(globalContext.itemInPreview!.previousItem.candidat.id as number)
               }
          }

          if (globalContext.itemInPreview.isPreviousItemInThePreviousPage) {
               globalContext.setFilters(prev => ({
                    ...prev,
                    page: prev.page - 1,
               }))
          }
     }

     // Handles navigation to next candidate
     function handleNavigateToNextCandidate() {
          if (!globalContext.itemInPreview) return

          if (globalContext.itemInPreview.nextItem) {
               globalContext.setItemInPreview(
                    getSelectedCandidatePlusPreviousAndNextCandidate(
                         globalContext.itemInPreview!.nextItem,
                         globalContext.itemInPreview!.selectedItemIndex + 1,
                         globalContext.listingQuery.data!.data,
                         globalContext.listingQuery.data!.page,
                         globalContext.listingQuery.data!.totalPages
                    )
               )

               if (Array.isArray(globalContext.filters.filters?.annonces) && (globalContext.filters?.filters?.annonces?.length ?? 0) > 0)
                    globalContext.checkItemAsSeen(globalContext.itemInPreview!.nextItem.candidat.id as number)
          }

          if (globalContext.itemInPreview.isNextItemInTheNextPage) {
               globalContext.setFilters(prev => ({
                    ...prev,
                    page: prev.page + 1,
               }))
          }
     }

     return (
          <div ref={globalContext.previewContainerRef}>
               <MyTooltip title={"Candidat précédent"}>
                    <button
                         className="btn btn-sm btn-active-light-primary p-0 py-3 px-4"
                         onClick={e => {
                              e.stopPropagation()
                              handleNavigateToPreviousCandidate()
                         }}
                         disabled={!globalContext.itemInPreview?.previousItem && !globalContext.itemInPreview?.isPreviousItemInThePreviousPage}
                    >
                         <i className="fas fa-angle-left text-dark fs-1"></i>
                    </button>
               </MyTooltip>
               <MyTooltip title={"Candidat suivant"}>
                    <button
                         className="btn btn-sm btn-active-light-primary p-0 py-3 px-4"
                         onClick={e => {
                              e.stopPropagation()
                              handleNavigateToNextCandidate()
                         }}
                         disabled={!globalContext.itemInPreview?.nextItem && !globalContext.itemInPreview?.isNextItemInTheNextPage}
                    >
                         <i className="fas fa-angle-right fs-1 text-dark"></i>
                    </button>
               </MyTooltip>
          </div>
     )
}

/* Statuts */
export const ActionsRapidesButton = () => {
     const [isAddingOrRemovingStatut, setIsAddingOrRemovingStatut] = useState<boolean>(false)
     const queryClient = useQueryClient()
     const globalContext = useSearchResultsContext()
     const selectedItemInPreview = globalContext.itemInPreview!.selectedItem
     const candidateInPreview = globalContext.listingQuery.data?.data.find(item => item.candidat.id === selectedItemInPreview?.candidat.id)

     function handleAddStatut(statut: string) {
          toast.dismiss()
          toast.info(
               "Cette fonctionnalité n'est plus d'actualité et sera supprimée dans la prochaine mise à jour. \n Veuillez utiliser le système de ressenti au niveau des échanges.",
               { autoClose: false }
          )
          return
          setIsAddingOrRemovingStatut(true)
          addStatut(candidateInPreview?.candidat.id as number, statut)
               .then(r => {
                    queryClient.setQueryData<ISearchResultsResponseModel | undefined>(
                         [globalContext.REACT_QUERY_KEY_SEARCH_RESULTS, globalContext.filters],
                         (prev: ISearchResultsResponseModel | undefined) => {
                              if (prev?.data) {
                                   const index = prev.data.findIndex(item_ => item_.candidat.id === candidateInPreview?.candidat.id)
                                   prev.data[index] = {
                                        ...prev.data[index],
                                        connectedUserAddedStatusToCandidat: r.data,
                                   }

                                   return prev
                              }

                              return prev
                         }
                    )
               })
               .finally(() => setIsAddingOrRemovingStatut(false))
     }

     function handleRemoveStatut(statut: string) {
          toast.dismiss()
          toast.info(
               "Cette fonctionnalité n'est plus d'actualité et sera supprimée dans la prochaine mise à jour. \n Veuillez utiliser le système de ressenti au niveau des échanges.",
               { autoClose: false }
          )
          return
          setIsAddingOrRemovingStatut(true)
          removeStatut(candidateInPreview?.candidat.id as number, statut)
               .then(r => {
                    queryClient.setQueryData<ISearchResultsResponseModel | undefined>(
                         [globalContext.REACT_QUERY_KEY_SEARCH_RESULTS, globalContext.filters],
                         (prev: ISearchResultsResponseModel | undefined) => {
                              if (prev?.data) {
                                   const index = prev.data.findIndex(item_ => item_.candidat.id === candidateInPreview?.candidat.id)
                                   prev.data[index] = {
                                        ...prev.data[index],
                                        connectedUserAddedStatusToCandidat: r.data,
                                   }

                                   return prev
                              }

                              return prev
                         }
                    )
               })
               .finally(() => setIsAddingOrRemovingStatut(false))
     }

     function isStatutChecked(statut: string) {
          return candidateInPreview?.connectedUserAddedStatusToCandidat?.find(item => item.contacteOrNotRetenuRaison === statut) !== undefined
     }

     return (
          <div className="dropdown me-6">
               <button className="btn btn-sm btn-dark p-0 px-3 py-2 py-sm-2 px-sm-3" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <span className={"d-none d-sm-inline-flex"}>Actions rapides</span> <i className={"fas fa-caret-down fs-4 fs-sm-7"} />
               </button>
               <ul className="dropdown-menu">
                    <li className={"text-center"}>{isAddingOrRemovingStatut && <MySimpleSpinner size={"sm"} />}</li>
                    <li>
                         <h6 className="dropdown-header">Déjà contacté par</h6>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Téléphone
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Email
                              </span>
                         </span>
                    </li>
                    <li>
                         <hr className="separator" />
                    </li>
                    <li>
                         <h6 className="dropdown-header">Non retenu pour cause de</h6>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Mobilité
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Compétences
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Disponibilité
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Rémunération
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Refus candidat
                              </span>
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={e => {
                                   e.stopPropagation()
                                   isStatutChecked(CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE)
                                        ? handleRemoveStatut(CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE)
                                        : handleAddStatut(CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE)
                              }}
                         >
                              <span className="form-check form-check-custom">
                                   <input
                                        type={"checkbox"}
                                        checked={isStatutChecked(CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE)}
                                        onChange={() => {}}
                                        className={"form-check-input border-secondary cursor-pointer h-15px w-15px rounded-0 me-2"}
                                   />
                                   Experience non adaptée
                              </span>
                         </span>
                    </li>
                    <li className={"text-center mt-5 mt-sm-2 cursor-pointer"}>
                         <button className={"btn btn-sm btn-dark p-0 px-2 p1-2"}>
                              Fermer <i className={"fas fa-close fs-7"} />
                         </button>
                    </li>
               </ul>
          </div>
     )
}

/* Recruter Button */
export const RecruterButton = () => {
     const navigate = useNavigate()
     const queryClient = useQueryClient()
     const globalContext = useSearchResultsContext()
     const selectedItemInPreview = globalContext.itemInPreview!.selectedItem
     const candidateInPreview = globalContext.listingQuery.data?.data.find(item => item.candidat.id === selectedItemInPreview?.candidat.id)
     const [isModalDemanderInfoPreEmbaucheShown, setIsModalDemanderInfoPreEmbaucheShown] = useState<boolean>(false)
     const [isModalEntamerDemandeEmbaucheShown, setIsModalEntamerDemandeEmbaucheShown] = useState<boolean>(false)

     function handleSubmitCallBackDemanderInfoPreEmbauche(demandeEmbauche: IConsultantDEModel) {
          queryClient.setQueryData<ISearchResultsResponseModel | undefined>(
               [globalContext.REACT_QUERY_KEY_SEARCH_RESULTS, globalContext.filters],
               (prev: ISearchResultsResponseModel | undefined) => {
                    if (prev?.data) {
                         const index = prev.data.findIndex(item_ => item_.candidat.id === candidateInPreview?.candidat.id)
                         prev.data[index] = {
                              ...prev.data[index],
                              activeDemandeEmbauche: demandeEmbauche,
                         }

                         return prev
                    }

                    return prev
               }
          )
          setIsModalDemanderInfoPreEmbaucheShown(false)
     }

     function handleSubmitCallBackEntamerDemandeEmbauche(demandeEmbauche: IConsultantDEModel) {
          navigate(`/recrutement/demandes-embauche/${demandeEmbauche.consultant!.id}/details`)
     }

     const FormDemandeInformationsPreEmabaucheInModal = useMemo(() => {
          return (
               <MyModal
                    title={<span>Faire remplir les informations par le candidat</span>}
                    show={true}
                    onCloseCallback={() => setIsModalDemanderInfoPreEmbaucheShown(false)}
                    size={"lg"}
               >
                    <CandidatDemanderInfoPreEmbaucheParMail candidat={candidateInPreview!.candidat} callBackOnSubmit={handleSubmitCallBackDemanderInfoPreEmbauche} />
               </MyModal>
          )
     }, [isModalDemanderInfoPreEmbaucheShown])

     const FormEntamerDemandeEmbaucheInModal = useMemo(() => {
          return (
               <MyModal
                    title={<span>Saisir moi-même les informations d'embauche</span>}
                    show={true}
                    onCloseCallback={() => setIsModalEntamerDemandeEmbaucheShown(false)}
                    size={"lg"}
               >
                    <CandidatEntamerDemandeEmbauche candidat={candidateInPreview!.candidat} callBackOnSubmit={handleSubmitCallBackEntamerDemandeEmbauche} />
               </MyModal>
          )
     }, [isModalEntamerDemandeEmbaucheShown])

     return (
          <>
               <div className="dropup me-6">
                    <button className="btn btn-sm btn-info p-0 px-3 py-2 py-sm-2 px-sm-3" type="button" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                         {/*<span className={"d-none d-sm-inline-flex"}>{candidateInPreview?.activeDemandeEmbauche ? "Poursuivre le recrutement" : "Recruter"}</span>{" "}*/}
                         <span className={"d-none d-sm-inline-flex"}>Recruter</span> <i className={"fas fa-door-open fs-4 fs-sm-7"} />
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="defaultDropdown">
                         <MyTooltip
                              title={
                                   "Cela enverra un mail au candidat afin qu'il puisse remplir ses informations personnelles et joindre ses documents d'embauche dans son espace Talent."
                              }
                         >
                              <li>
                                   <span
                                        className="dropdown-item cursor-pointer"
                                        onClick={() => {
                                             setIsModalDemanderInfoPreEmbaucheShown(true)
                                        }}
                                   >
                                        Faire remplir les informations par le candidat
                                   </span>
                              </li>
                         </MyTooltip>

                         <li>
                              <span className="dropdown-item cursor-pointer" onClick={() => setIsModalEntamerDemandeEmbaucheShown(true)}>
                                   Saisir moi-même les informations d'embauche
                              </span>
                         </li>
                    </ul>
               </div>

               {/* Modal demande information pre-embauche & entamer DE forms */}
               {isModalDemanderInfoPreEmbaucheShown && <>{FormDemandeInformationsPreEmabaucheInModal}</>}
               {isModalEntamerDemandeEmbaucheShown && <>{FormEntamerDemandeEmbaucheInModal}</>}
          </>
     )
}

/* Curriculum with utils like download/replace CV, send mail, share profil ... */
export const CurriculumIframeWithUtils = () => {
     const queryClient = useQueryClient()
     const globalContext = useSearchResultsContext()
     const previewContent = useSearchResultsPreviewContext()
     const { currentUser } = useAuth()

     const selectedItemInPreview = globalContext.itemInPreview!.selectedItem
     const candidateInPreview = globalContext.listingQuery.data?.data.find(itm => itm.candidat.id === selectedItemInPreview?.candidat.id)
     const refReplaceCurriculumButton = useRef<any>(null)

     // Blacklist states
     const [isBlacklistModalOpen, setIsBlacklistModalOpen] = useState(false)
     const [blacklistComment, setBlacklistComment] = useState("")
     const [isSubmittingBlacklist, setIsSubmittingBlacklist] = useState(false)

     // Blacklist check
     const myPersonnelId = currentUser?.personnel.id
     const myTeamIds = currentUser?.teamRecrutement?.map(p => p.id) || []
     const isAlreadyBlacklistedByTeam = candidateInPreview?.candidat.candidatSuivis?.some(
          s => s.type === CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE && (s.personnel?.id === myPersonnelId || myTeamIds.includes(s.personnel?.id))
     )

     const handleAddBlacklist = async () => {
          if (!blacklistComment.trim()) {
               toast.error("Un commentaire est requis.")
               return
          }
          setIsSubmittingBlacklist(true)
          try {
               await axios.post(CONST_API_RECRUITMENT_CANDIDATES_POST_ADD_BLACKLIST_ENDPOINT(candidateInPreview?.candidat.id as number), {
                    commentaire: blacklistComment,
               })
               toast.success("Candidat blacklisté.")
               setIsBlacklistModalOpen(false)
               setBlacklistComment("")
               globalContext.handleRefreshItemOfTheList([candidateInPreview!], {
                    page: 1,
                    pageLength: null,
                    filters: { ids: [candidateInPreview?.candidat.id!] },
               })
          } catch (e: any) {
               toast.error(e.response?.data?.detail || "Erreur blacklist")
          } finally {
               setIsSubmittingBlacklist(false)
          }
     }

     function handleDownloadCurriculum() {
          toast.info("Téléchargement en cours ...", { ...CONST_DEFAULT_TOAST_OPTIONS, autoClose: false })
          axios.get(CONST_API_RECRUITMENT_CANDIDATES_GET_DOWNLOAD_CURRICULUM_ENDPOINT(candidateInPreview?.candidat.id as number), { responseType: "blob" })
               .then(r => {
                    const fileName = `CV_${candidateInPreview?.candidat.prenom}_${candidateInPreview?.candidat.nom}.${
                         candidateInPreview?.googleDriveMimeTypeForCv ? FileAndDriveHelper.getExtensionAccordingToMimetype(candidateInPreview.googleDriveMimeTypeForCv) : ""
                    }`
                    FileAndDriveHelper.downloadFile(r.data, fileName)
                    toast.dismiss()
                    toast.success("CV téléchargé")
               })
               .catch(() => {
                    toast.dismiss()
                    toast.error("Erreur téléchargement CV.")
               })
     }

     function handleReplaceCurriculum(event: any) {
          const file = event.target.files[0]
          if (file) {
               toast.info("Remplacement...", { ...CONST_DEFAULT_TOAST_OPTIONS, autoClose: false })
               replaceCurriculum(candidateInPreview?.candidat.id as number, file)
                    .then(r => {
                         queryClient.setQueryData([globalContext.REACT_QUERY_KEY_SEARCH_RESULTS, globalContext.filters], (prev: any) => {
                              if (prev?.data) {
                                   const idx = prev.data.findIndex(itm => itm.candidat.id === candidateInPreview?.candidat.id)
                                   prev.data[idx] = { ...prev.data[idx], googleDriveIdForCv: r.data.googleDriveId, googleDriveMimeTypeForCv: r.data.googleDriveMimeType }
                              }
                              return prev
                         })
                         toast.dismiss()
                         toast.success("CV remplacé.")
                    })
                    .catch((e: AxiosError) => {
                         toast.dismiss()
                         toast.error(e?.response?.data.detail)
                    })
          }
     }

     return (
          <>
               <iframe
                    onLoad={() => {
                         previewContent.setIsPreviewBodyLoading(false)
                         globalContext.setItemInPreview(prev => (prev ? { ...prev, isSelectedItemLoading: false } : null))
                    }}
                    className={"preview-height"}
                    allowFullScreen={true}
                    src={FileAndDriveHelper.getUrlOfDriveFilePreview(candidateInPreview?.googleDriveIdForCv as string)}
                    sandbox="allow-scripts allow-same-origin allow-popups"
               />
               <div className={"vertical-container-of-button-on-iframe bg-secondary rounded text-center"}>
                    <MyTooltip title={"Télécharger le CV"} placement={"right"}>
                         <button type="button" className="btn btn-outline btn-outline-dark btn-sm btn-icon rounded-circle mb-2" onClick={handleDownloadCurriculum}>
                              <i className="fas fa-download" />
                         </button>
                    </MyTooltip>

                    <MyTooltip title={"Remplacer le CV"} placement={"right"}>
                         <span>
                              <input type="file" className="d-none" ref={refReplaceCurriculumButton} onChange={handleReplaceCurriculum} />
                              <button className="btn btn-outline btn-outline-dark btn-sm btn-icon rounded-circle mb-2" onClick={() => refReplaceCurriculumButton.current.click()}>
                                   <i className="fas fa-sync" />
                              </button>
                         </span>
                    </MyTooltip>

                    <div className="separator separator-dashed border-white mb-2 mt-2"></div>

                    {/* BLACKLIST BUTTON */}
                    {!isAlreadyBlacklistedByTeam && (
                         <MyTooltip title={"Blacklister le candidat"} placement={"right"}>
                              <button
                                   type="button"
                                   className="btn btn-outline btn-outline-danger btn-sm btn-icon rounded-circle mb-2"
                                   onClick={() => setIsBlacklistModalOpen(true)}
                              >
                                   <i className="fas fa-user-slash" />
                              </button>
                         </MyTooltip>
                    )}

                    {candidateInPreview?.candidat.tel && (
                         <MyTooltip title={"Appeler"} placement={"right"}>
                              <a
                                   href={`tel:${candidateInPreview.candidat.telIndicatif?.phoneCodeWithPlusPrefix} ${candidateInPreview.candidat.tel}`}
                                   className="btn btn-success p-0 px-3 py-2 mb-2"
                              >
                                   <i className="fas fa-phone" />
                              </a>
                         </MyTooltip>
                    )}

                    <MyTooltip title={"Envoyer un mail"} placement={"right"}>
                         <a
                              href={`mailto:${candidateInPreview?.candidat.email}`}
                              target="_blank"
                              className="btn btn-outline btn-outline-primary btn-sm btn-icon rounded-circle mb-2"
                         >
                              <i className="fas fa-envelope" />
                         </a>
                    </MyTooltip>

                    <MyTooltip title={"Ajouter à un vivier"} placement={"right"}>
                         <button
                              type="button"
                              className="btn btn-outline btn-outline-danger btn-sm btn-icon rounded-circle mb-2"
                              onClick={() => candidateInPreview && globalContext.setAddingCandidatesToViviers([candidateInPreview])}
                         >
                              <i className="fas fa-heart fs-6" />
                         </button>
                    </MyTooltip>

                    <MyTooltip title={candidateInPreview?.doesConnectedUserAddedCandidatInListeTraitement ? "Supprimer de ma liste" : "Ajouter à ma liste"} placement={"right"}>
                         <button
                              type="button"
                              className={`btn ${
                                   candidateInPreview?.doesConnectedUserAddedCandidatInListeTraitement ? "btn-warning" : "btn-outline btn-outline-warning"
                              } btn-sm btn-icon rounded-circle mb-2`}
                              onClick={() =>
                                   !globalContext.addingOrRemovingCandidatesToFromListeTraitement?.find(itm => itm.candidat.id === candidateInPreview?.candidat.id) &&
                                   (candidateInPreview?.doesConnectedUserAddedCandidatInListeTraitement
                                        ? globalContext.handleRemoveFromListeTraitement([candidateInPreview!])
                                        : globalContext.handleAddToListeTraitement([candidateInPreview!]))
                              }
                         >
                              {candidateInPreview?.doesConnectedUserAddedCandidatInListeTraitement ? <i className="fas fa-minus fs-2" /> : <i className="fas fa-plus fs-2" />}
                         </button>
                    </MyTooltip>

                    <MyTooltip title={"Partager le profil"} placement={"right"}>
                         <button
                              type="button"
                              className="btn btn-outline btn-outline-dark btn-sm btn-icon rounded-circle"
                              onClick={() => candidateInPreview && globalContext.setSharingCandidate(candidateInPreview)}
                         >
                              <i className="fas fa-share fs-6" />
                         </button>
                    </MyTooltip>
               </div>

               {isBlacklistModalOpen && (
                    <MyModal
                         title={
                              <span className="text-danger">
                                   <i className="fas fa-ban me-2" />
                                   Blacklister {candidateInPreview?.candidat.prenomNom}
                              </span>
                         }
                         show={true}
                         onCloseCallback={() => setIsBlacklistModalOpen(false)}
                    >
                         <div className="p-2">
                              <div className="alert alert-dismissible bg-light-danger border border-danger border-dashed d-flex flex-column p-5 mb-5">
                                   <div className="d-flex align-items-center mb-2">
                                        <i className="fas fa-exclamation-circle fs-2hx text-danger me-4" />
                                        <h5 className="mb-0 text-danger">Attention</h5>
                                   </div>
                                   <span className="fs-7">Ce candidat sera marqué comme "Non recommandé" pour tout le groupe.</span>
                              </div>
                              <label className="form-label fw-boldest fs-6 required">Motif de la blacklist</label>
                              <MyEditorField value={blacklistComment} onChange={setBlacklistComment} height={300} placeholder="Expliquez pourquoi..."/>
                              <div className="d-flex justify-content-end gap-3 mt-5">
                                   <button className="btn btn-sm btn-light" onClick={() => setIsBlacklistModalOpen(false)}>
                                        Annuler
                                   </button>
                                   <button className="btn btn-sm btn-danger fw-boldest" onClick={handleAddBlacklist} disabled={isSubmittingBlacklist}>
                                        {isSubmittingBlacklist ? <MySimpleSpinner size="sm" /> : "CONFIRMER"}
                                   </button>
                              </div>
                         </div>
                    </MyModal>
               )}
          </>
     )
}

/* Échanges: message répondeur, DMS, entretien en agence, RQ */
export const AjouterUnSuiviButton = () => {
     const globalContext = useSearchResultsContext()
     const selectedItemInPreview = globalContext.itemInPreview!.selectedItem
     const candidateInPreview = globalContext.listingQuery.data?.data.find(item => item.candidat.id === selectedItemInPreview?.candidat.id)

     return (
          <div className="dropup me-6">
               <button className="btn btn-sm btn-info p-0 px-3 py-2 py-sm-2 px-sm-3" type="button" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false">
                    <span className={"d-none d-sm-inline-flex"}>Ajouter un échange</span> <i className={"fas fa-plus fs-4 fs-sm-7"} />
               </button>
               <ul className="dropdown-menu" aria-labelledby="defaultDropdown">
                    <li>
                         <h6 className="dropdown-header">Échanges</h6>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                   globalContext.setAddingSuiviToCandidate({
                                        item: candidateInPreview as ISearchResultsDataItemResponseModel,
                                        suiviType: CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR,
                                   })
                              }
                         >
                              Message répondeur
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                   globalContext.setAddingSuiviToCandidate({
                                        item: candidateInPreview as ISearchResultsDataItemResponseModel,
                                        suiviType: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE,
                                   })
                              }
                         >
                              DMS
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                   globalContext.setAddingSuiviToCandidate({
                                        item: candidateInPreview as ISearchResultsDataItemResponseModel,
                                        suiviType: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS,
                                   })
                              }
                         >
                              Entretien en agence / visio
                         </span>
                    </li>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                   globalContext.setAddingSuiviToCandidate({
                                        item: candidateInPreview as ISearchResultsDataItemResponseModel,
                                        suiviType: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT,
                                   })
                              }
                         >
                              Réunion de qualif. (RQ)
                         </span>
                    </li>
                    <span className={"separator my-1"}></span>
                    <li>
                         <span
                              className="dropdown-item cursor-pointer"
                              onClick={() =>
                                   globalContext.setAddingSuiviToCandidate({
                                        item: candidateInPreview as ISearchResultsDataItemResponseModel,
                                        suiviType: CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE,
                                   })
                              }
                         >
                              Commentaire
                         </span>
                    </li>
               </ul>
          </div>
     )
}

// Wrapper Suivi
export const SuiviFormModal = () => {
     const queryClient = useQueryClient()
     const globalContext = useSearchResultsContext()
     const item = globalContext.listingQuery.data?.data.find(
          item_ => item_.candidat.id === globalContext.addingSuiviToCandidate!.item!.candidat.id
     ) as ISearchResultsDataItemResponseModel

     if (globalContext.addingSuiviToCandidate) {
          switch (globalContext.addingSuiviToCandidate.suiviType) {
               case CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE:
                    return (
                         <MyModal
                              title={<span>DMS de {item.candidat.prenomNom}</span>}
                              show={true}
                              onCloseCallback={() => globalContext.setAddingSuiviToCandidate(null)}
                              fullscreen
                         >
                              <CandidatAddSuiviTelForm
                                   candidat={{ id: item.candidat?.id as number, prenomNom: item.candidat?.prenomNom as string, type: item.candidat.type! }}
                                   curriculumGoogleDriveUrl={FileAndDriveHelper.getUrlOfDriveFilePreview(item.googleDriveIdForCv as string)}
                                   handleSubmitCallBack={({ suivi, candidat }) => {
                                        queryClient.setQueryData<ISearchResultsResponseModel | undefined>(
                                             [globalContext.REACT_QUERY_KEY_SEARCH_RESULTS, globalContext.filters],
                                             (prev: ISearchResultsResponseModel | undefined) => {
                                                  if (prev?.data) {
                                                       const index = prev.data.findIndex(item_ => item_.candidat.id === item.candidat.id)
                                                       prev.data[index] = {
                                                            ...prev.data[index],
                                                            candidat: { ...prev.data[index].candidat, ...candidat },
                                                            entretienTelOfConnectedUserAndHisTeam: [suivi, ...prev.data[index].entretienTelOfConnectedUserAndHisTeam],
                                                       }

                                                       return prev
                                                  }

                                                  return prev
                                             }
                                        )

                                        globalContext.setAddingSuiviToCandidate(null)
                                        if (globalContext.previewActiveTab === "suivis") {
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY, item.candidat.id])
                                        }
                                        if (globalContext.previewActiveTab === "details")
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY, item.candidat.id])
                                   }}
                              />
                         </MyModal>
                    )
               case CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR:
                    return (
                         <MyModal
                              title={<span>Message répondeur pour {item.candidat.prenomNom}</span>}
                              show={true}
                              onCloseCallback={() => globalContext.setAddingSuiviToCandidate(null)}
                              fullscreen
                         >
                              <CandidatAddSuiviMessageRepondeurForm
                                   candidat={{ id: item.candidat?.id as number, prenomNom: item.candidat?.prenomNom as string, type: item.candidat?.type! }}
                                   curriculumGoogleDriveUrl={FileAndDriveHelper.getUrlOfDriveFilePreview(item.googleDriveIdForCv as string)}
                                   handleSubmitCallBack={() => {
                                        globalContext.setAddingSuiviToCandidate(null)
                                        if (globalContext.previewActiveTab === "suivis") queryClient.invalidateQueries([REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY, item.candidat.id])
                                        if (globalContext.previewActiveTab === "details")
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY, item.candidat.id])
                                   }}
                              />
                         </MyModal>
                    )
               case CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE:
                    return (
                         <MyModal
                              title={<span>Message répondeur pour {item.candidat.prenomNom}</span>}
                              show={true}
                              onCloseCallback={() => globalContext.setAddingSuiviToCandidate(null)}
                         >
                              <CandidatAddSuiviCommentaireSimple
                                   candidat={{ id: item.candidat?.id as number, prenomNom: item.candidat?.prenomNom as string, type: item.candidat?.type! }}
                                   handleSubmitCallBack={() => {
                                        globalContext.setAddingSuiviToCandidate(null)
                                        if (globalContext.previewActiveTab === "suivis") queryClient.invalidateQueries([REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY, item.candidat.id])
                                        if (globalContext.previewActiveTab === "details")
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY, item.candidat.id])
                                   }}
                              />
                         </MyModal>
                    )
               case CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS:
                    return (
                         <MyModal
                              title={<span>Entretien de pré-qualification avec {item.candidat.prenomNom}</span>}
                              show={true}
                              onCloseCallback={() => globalContext.setAddingSuiviToCandidate(null)}
                              fullscreen
                         >
                              <CandidatAddSuiviEntretienAgenceOuVisioForm
                                   candidat={{ id: item.candidat?.id as number, prenomNom: item.candidat?.prenomNom as string, type: item.candidat?.type! }}
                                   curriculumGoogleDriveUrl={FileAndDriveHelper.getUrlOfDriveFilePreview(item.googleDriveIdForCv as string)}
                                   handleSubmitCallBack={() => {
                                        globalContext.setAddingSuiviToCandidate(null)
                                        if (globalContext.previewActiveTab === "suivis") queryClient.invalidateQueries([REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY, item.candidat.id])
                                        if (globalContext.previewActiveTab === "details")
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY, item.candidat.id])
                                   }}
                              />
                         </MyModal>
                    )
               case CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT:
                    return (
                         <MyModal
                              title={<span>Réunion de qualification de {item.candidat.prenomNom}</span>}
                              show={true}
                              onCloseCallback={() => globalContext.setAddingSuiviToCandidate(null)}
                              fullscreen
                         >
                              <CandidatAddSuiviEntretienQualifForm
                                   candidat={{ id: item.candidat?.id as number, prenomNom: item.candidat?.prenomNom as string, type: item.candidat.type! }}
                                   curriculumGoogleDriveUrl={FileAndDriveHelper.getUrlOfDriveFilePreview(item.googleDriveIdForCv as string)}
                                   handleSubmitCallBack={() => {
                                        globalContext.setAddingSuiviToCandidate(null)
                                        if (globalContext.previewActiveTab === "suivis") queryClient.invalidateQueries([REACT_QUERY_KEY_GET_SUIVI_LISTING_QUERY, item.candidat.id])
                                        if (globalContext.previewActiveTab === "details")
                                             queryClient.invalidateQueries([REACT_QUERY_KEY_GET_CANDIDAT_DETAILS_QUERY, item.candidat.id])
                                   }}
                              />
                         </MyModal>
                    )
               default:
                    return <span>Pas de suivi possible</span>
          }
     }

     return <span>Pas de suivi possible</span>
}
